import { APP_ID, ErrorHandler, NgModule, provideZoneChangeDetection } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServiceWorkerModule, SwRegistrationOptions } from '@angular/service-worker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { QuicklinkModule } from 'ngx-quicklink';
import { ToastrModule, ToastContainerDirective } from 'ngx-toastr';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HandleUnrecoverableStateService  } from './services/service-workers/handle-unrecoverable-state.service';
import { CheckForUpdateService } from './services/service-workers/check-for-update.service';
import { LogUpdateService } from './services/service-workers/log-update.service';
import { PromptUpdateService } from './services/service-workers/prompt-update.service';
import { RollbarErrorHandler, rollbarFactory, RollbarService } from '../rollbar_config';

/**
 * This is the first module loaded. It bootstraps
 * the rest of the application.
 */
@NgModule({
	declarations: [ AppComponent ]
    , imports: [
		BrowserModule
		, CoreModule
		, QuicklinkModule
		, BrowserAnimationsModule
        , ToastrModule.forRoot({
            maxOpened: 2
            , autoDismiss: true 
            , newestOnTop: true
        }) 
        , ToastContainerDirective
		, ServiceWorkerModule.register(
			'ngsw-worker.js'
			, {
				enabled: true
				, registrationStrategy: 'registerWhenStable:30000'
			}
		)
        , ModalModule
        , MatProgressSpinnerModule        
	]
    , providers: [
        CheckForUpdateService
        , LogUpdateService
		, PromptUpdateService
		, HandleUnrecoverableStateService
		, { 
			provide: ErrorHandler
			, useClass: RollbarErrorHandler 
		}
        , { 
			provide: RollbarService
			, useFactory: rollbarFactory 
		}
        , {
            provide: SwRegistrationOptions
            , useFactory: () => ({ enabled: true })
        }
        , { 
            provide: APP_ID,  
            useValue: 'ng-cli-universal' 
        }
        , provideAnimationsAsync()
        , providePrimeNG(
            {
                theme: {
                    preset: Aura
                    , options: { darkModeSelector: '.dark-theme' }
                }
            }
        )
        , provideZoneChangeDetection()
	]
    , bootstrap: [ AppComponent ]
})
export class AppModule {}
